import { Injectable } from "@angular/core";
import { HttpClient } from "../shared/wrappers/HttpClient";


@Injectable()
export class DashboardService {
    constructor(private httpClient: HttpClient) { }

    endPoint: String = '/dashboard';
    data:any;

    async getFinanceData(year,month,typeDimension){
        let query = `?year=${year}&month=${month}&typeDimension=${typeDimension}`;
        this.data = await this.httpClient.get(`${this.endPoint}/finance/${query}`);
        return this.data;
    }

    async getJudiciaryData(year: string,month: string){
        let query = `?year=${year}&month=${month}`;
        this.data = await this.httpClient.get(`${this.endPoint}/judiciary/${query}`);
        return this.data;
    }

}




// WEBPACK FOOTER //
// ./src/app/services/dashboard.service.ts